// Zeepy Universal FAQ Accordion (event delegation + a11y)
// Works for any .faq-item added now or later (theme/app sections)

(function initWhenReady(init) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})(function initZeepyFAQ() {
  // Click anywhere on a .faq-question (even if injected later)
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".faq-question");
    if (!btn) return;

    const item = btn.closest(".faq-item");
    if (!item) return;

    // Find the nearest container that holds multiple FAQ items (so we only close siblings)
    let container = item.parentElement;
    while (container && container.querySelectorAll && container.querySelectorAll(".faq-item").length < 2) {
      container = container.parentElement;
    }
    if (!container) container = document;

    // Toggle behavior: one open at a time within the container
    const isOpen = item.classList.contains("active");
    container.querySelectorAll(".faq-item.active").forEach(el => {
      if (el !== item) el.classList.remove("active");
      const q = el.querySelector(".faq-question");
      if (q) q.setAttribute("aria-expanded", "false");
    });

    // Toggle current
    item.classList.toggle("active", !isOpen);
    btn.setAttribute("aria-expanded", String(!isOpen));
  });

  // Accessibility: ensure buttons have correct role/expanded
  function primeAria(root = document) {
    root.querySelectorAll(".faq-question").forEach(q => {
      if (!q.hasAttribute("aria-expanded")) q.setAttribute("aria-expanded", "false");
      if (!q.hasAttribute("role")) q.setAttribute("role", "button");
    });
  }

  primeAria();

  // If theme re-renders sections, re-prime ARIA on load
  document.addEventListener("shopify:section:load", (evt) => primeAria(evt.target));
  document.addEventListener("shopify:section:select", (evt) => primeAria(evt.target));
});